import request from '@/router/axios'

//获取标签
export function getOrganizationTag () {
  return request({
    url: '/admin/admin/member/organization-tag/all',
    method: 'get'
  })
}

//创建投票
export function createVote (obj) {
  return request({
    url: '/vote/admin/vote',
    method: 'post',
    data: obj,
  })
}

//投票详情
export function getVoteDetail (id) {
  return request({
    url: `/vote/admin/vote/${id}`,
    method: 'get',
  })
}

//投票列表
export function getVoteList (param) {
  return request({
    url: '/vote/admin/votes',
    method: 'get',
    params: param,
  })
}

//删除投票
export function voteDel (id) {
  return request({
    url: `/vote/admin/vote/${id}`,
    method: 'delete',
  })
}

//编辑投票
export function voteEdit (obj) {
  return request({
    url: `/vote/admin/vote/${obj.id}`,
    method: 'put',
    data: obj,
  })
}

//发布投票
export function votePublish (voteId, isSendMessage, message) {
  return request({
    url: `/vote/admin/vote/${voteId}/publish`,
    method: 'put',
    params: {
      isSendMessage,
      message,
    }
  })
}

//暂停投票
export function votePause (voteId, isSendMessage, message) {
  return request({
    url: `/vote/admin/vote/${voteId}/pause`,
    method: 'put',
    params: {
      isSendMessage,
      message,
    }
  })
}

//参选人员列表
export function getVoterList (optionId) {
  return request({
    url: `/vote/admin/option/${optionId}/voter`,
    method: 'get',
  })
}

//投票结果
export function getRecord (voteId) {
  return request({
    url: `/vote/admin/${voteId}`,
    method: 'get',
  })
}


